import { useState, ChangeEvent, KeyboardEvent } from 'react';
import { useDataGrid } from '@/hooks/useDataGrid';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { MdSearch } from 'react-icons/md';

export function SearchField() {
  const { search, setSearch } = useDataGrid();
  const [value, setValue] = useState<string>(search);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setValue(e.currentTarget.value);
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      setSearch(value);
    }
  }

  function handleBlur() {
    setSearch(value);
  }

  return (
    <InputGroup role='search' aria-label='Pesquisa' w="auto" mr={3}>
      <InputLeftElement
        pointerEvents="none"
        aria-describedby='icone-lupa'
        aria-label='Icone-Pesquisa'
        h={"30px"}
        >
        <MdSearch />
      </InputLeftElement>
      <Input
        h={"30px"}
        placeholder="Pesquisar"
        value={value}
        aria-label='Campo-Pesquisa'
        aria-describedby='campo-pesquisa'
        aria-description='Digite para pesquisar na tabela'
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </InputGroup>
  );
}
